import { RecheckEligibilityScreen } from "@/interactors/RecheckEligibilityScreen";

export default function RecheckEligibility() {
  return <RecheckEligibilityScreen />;
}
